var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-wrapper"},[_c('input',{attrs:{"type":"checkbox","id":"agree","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_c('span',{staticClass:"custom-checkbox"})])
}
var staticRenderFns = []

export { render, staticRenderFns }